<template>
  <div id="app" class="d-flex flex-column flex-grow-1">
    <div>
      <custom-navbar />
      <router-view />
    </div>
    <custom-footer />
  </div>
</template>

<script>
import CustomFooter from './components/Core/CustomFooter'
import CustomNavbar from './components/Core/CustomNavbar'

export default {
  components: {
    CustomNavbar,
    CustomFooter,
  },
}
</script>

<style lang="scss">
#app {
  font-size: 0.8rem;
  min-height: 100vh;
  position: relative;
  justify-content: space-between;
}

body {
  background-color: var(--primaryBGColor) !important;
}

/* Modals are rendered under <body>, outside #app: align their text with the page font size. */
.modal-content {
  font-size: 0.8rem;
}

.modal-title {
  font-size: 1rem;
}

input,
select {
  background-color: var(--secondaryBGColor) !important;
}

input:disabled,
select:disabled {
  background-color: #e9ecef !important;
}

.form-control:focus,
.custom-select:focus {
  box-shadow: none !important;
  border-color: var(--formOutlineColor) !important;
}

a.dropdown-item {
  color: var(--primary);
}

.pointer {
  cursor: pointer !important;
}

/* Companion utility to .pointer above — the two are always applied together
   (class="pointer fairmatPrimary") to make a piece of text read as a clickable primary-colored
   link, e.g. ProductDetails.vue's "Storico indicatori"/"Compara col mercato" cross-links.
   It belongs here, not scoped per-component: it's a genuine cross-page utility class (also used
   by InvestmentOptionDetailPanel.vue), matching .pointer's own placement right above. */
.fairmatPrimary {
  color: var(--primary);
}

.emptyField,
.validationError {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

/*keep spinner z-i to 1000, bv-modal is set to 1040*/
.vld-overlay {
  z-index: 1000 !important;
}

.fairmat-primary-tabs .nav-link {
  border: 0 !important;
  color: black !important;
  background-color: transparent !important;
}

.fairmat-primary-tabs .nav-item .active {
  font-weight: bold !important;
  border-color: initial !important;
  background-color: transparent !important;
  border-bottom: 4px var(--primary) solid !important;
}

.fairmat-secondary-tabs .nav-tabs {
  border: 0 !important;
}

.fairmat-secondary-tabs .nav-link {
  margin-left: 6px;
  padding: 3px 10px;
  border: 1px solid #e2e8f0 !important;
  border-radius: 20px;
  background: #f1f5f9 !important;
  color: #475569 !important;
  font-weight: 500;
  white-space: nowrap;
  transition: background 0.12s, color 0.12s, border-color 0.12s;
}

.fairmat-secondary-tabs .nav-link:hover {
  background: #e5e7eb !important;
  border-color: #cbd5e1 !important;
  color: #374151 !important;
}

.fairmat-secondary-tabs .nav-item .active {
  border-radius: 20px;
  border-bottom: 0 !important;
  font-weight: 600 !important;
  border: 1px solid #d1d5db !important;
  background: #e5e7eb !important;
  color: #374151 !important;
}

</style>
